import { render, staticRenderFns } from "./ResolveAction.vue?vue&type=template&id=fbf7a42c&scoped=true&"
import script from "./ResolveAction.vue?vue&type=script&lang=js&"
export * from "./ResolveAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveAction.vue?vue&type=style&index=0&id=fbf7a42c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7a42c",
  null
  
)

export default component.exports